import { render, staticRenderFns } from "./leaderboard.vue?vue&type=template&id=a6d29fee&scoped=true"
import script from "./leaderboard.vue?vue&type=script&lang=js"
export * from "./leaderboard.vue?vue&type=script&lang=js"
import style0 from "./leaderboard.vue?vue&type=style&index=0&id=a6d29fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d29fee",
  null
  
)

export default component.exports